import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcHelpFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.25c5.385 0 9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25M12 15a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.086-7.993c-1.342.148-2.318 1.002-2.643 2.312a.75.75 0 0 0 1.457.36c.174-.7.633-1.102 1.35-1.181.858-.094 1.556.41 1.684 1.133.04.223-.027.475-.239.75a2.5 2.5 0 0 1-.884.69c-.61.29-1.39.95-1.389 1.929a.75.75 0 0 0 1.5 0c0-.126.143-.39.531-.573a4 4 0 0 0 1.433-1.133c.386-.503.658-1.172.524-1.925-.287-1.625-1.812-2.528-3.324-2.362",
    clipRule: "evenodd"
  }));
}
var IcHelpFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcHelpFill));

export { IcHelpFill as I };
